module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('worker-filter'), _vm._v(" "), _c('div', {
    staticClass: "title"
  }), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/student-check-in"
    }
  }, [_c('button', {
    staticClass: "base-btn qiandao",
    on: {
      "click": _vm.selectSign
    }
  }, [_vm._v("\n      签 到\n    ")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/student-list"
    }
  }, [_c('button', {
    staticClass: "base-btn huamingce"
  }, [_vm._v("\n      学员花名册\n    ")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6f4b8d0e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Work.vue
// module id = 785
// module chunks = 1